import { t, TFunction } from 'i18next';
import { NotificationStatus } from 'src/types/handover';

export const translateStatus = (status: NotificationStatus, t: TFunction): string => {

  switch (status) {
    case NotificationStatus.DELIVERED:
      return t('notifications.status.delivered');
    case NotificationStatus.CANCELED:
      return t('notifications.status.cancelled');
    case NotificationStatus.FAILED:
      return t('notifications.status.failed');
    case NotificationStatus.SCHEDULED:
      return t('notifications.status.scheduled');
    default:
      return t('notifications.status.unknown');
  }
};

export const statusToColor = (status: NotificationStatus): string => {
  switch (status) {
    case NotificationStatus.CANCELED:
      return '#FFECEB';
    case NotificationStatus.DELIVERED:
      return '#DCF9EC';
    default:
      return '';
  }
};
